import {faLock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useAuthz from "hooks/useAuthz";
import React, {useState} from "react";

const Accueil = () => {
	const [authz, user, profil] = useAuthz();
	const [height] = useState(window.innerHeight - 160);

	return (
		<div>
			{
				user.validated === false &&
				<div className="row" style={{height: "150px", alignItems: "center", backgroundColor: "white"}}>
					<FontAwesomeIcon icon={faLock} size={"3x"}/>
					<p className="error-page">Votre compte est en attente de validation côté Sanef, merci de revenir ultérieurement</p>
				</div>
			}
		</div>
	);

}


export default Accueil;
